import React from "react";
import Synonyms from "./Synonyms";
import Examples from "./Examples";
import "./Meaning.css";

export default function Meaning(props){
    return (
        <div className="Meaning">
            <h3>{props.meaning.partOfSpeech}</h3>
            {props.meaning.definitions.map(function(definition, index){
                return (
                    <div key={index}>
                        <div className="definition">
                            <h6 className="definition-title"><strong>Definition: </strong></h6>{definition.definition}
                        </div>
                        <div className="examples">
                            <Examples example={definition.example} />
                        </div>
                        <div className="synonyms">
                            <Synonyms synonyms={definition.synonyms} />
                        </div>
                    </div> 
                );
            })}
        </div>  
    );
}